﻿import { CommonFlags as c, DefaultColumns, EntityColumn, EntityDefinition, MicroMClient, ValuesObject } from "@mcurros2/microm";
import { catGenero } from "../Categorias y Estados/catGenero";
import { catTiposMedidasRopa } from "../Categorias y Estados/catTiposMedidasRopa";

const columns = () =>
(
    {
        c_ropa_id: new EntityColumn<string>({ name: 'c_ropa_id', type: 'char', length: 20, flags: c.PKAutonum, prompt: 'Ropa Id' }),
        vc_descripcion: new EntityColumn<string>({ name: 'vc_descripcion', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Descripción' }),
        vc_generos: new EntityColumn<string>({ name: 'vc_generos', type: 'varchar', flags: c.Edit, prompt: 'Generos', isArray: true }),
        c_tipomedidaropa_id: new EntityColumn<string>({ name: 'c_tipomedidaropa_id', type: 'char', length: 20, flags: c.Edit, prompt: 'Tipo de Talle' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        ropa_brwStandard: { name: 'ropa_brwStandard', keyMappings: { c_ropa_id: 0 } }
    }
)


const lookups = () =>
(
    {
        'Genero': {
            name: 'Genero',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new catGenero(client, parentKeys)
        },

        'TiposMedidasRopa': {
            name: 'TiposMedidasRopa',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new catTiposMedidasRopa(client, parentKeys)
        }
    }
)

export class RopaDef extends EntityDefinition {

    columns = columns();
    views = views();
    lookups = lookups();

    constructor() {
        super('Ropa');
    }
}